module.exports = __webpack_public_path__ + "static/media/Beverage.b13fb8b5.svg";